module.exports = __webpack_public_path__ + "static/media/aixin2.46311656.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aixin2.png
// module id = 1712
// module chunks = 0 1